import { CLAIM_FIELDS } from '@/graphql/fragments/claims';
import { gql } from '@apollo/client';

export const GET_CLAIMS = gql`
    ${CLAIM_FIELDS}
    query GetClaims($where: claims_bool_exp) {
        claims(where: $where) {
            ...ClaimFields
            shipper {
                client_id
                business_name
            }
            carrier {
                client_id
                business_name
            }
            middle_mile_carrier {
                client_id
                business_name
            }
            order {
                order_id
                order_number
                po_number
            }
        }
    }
`;
